import React from "react";
import { SITE_URL } from "@/misc/constants";

export default () => (
  <>
    <h1>ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ</h1>
    <h2>1. ОБЩИЕ ПОЛОЖЕНИЯ</h2>
    <p>Настоящее Пользовательское соглашение (далее – <strong>Соглашение</strong>) относится к Сайту интернет-сервиса «Lakki CRM», расположенному по адресу <a href="https://lakki-app.com">https://lakki-app.com</a>, и ко всем соответствующим Сайтам и мобильным приложениям, связанным с Сайтом интернет-сервиса.</p>
    <p>1.1. Сайт интернет-сервиса «Lakki CRM» (далее – <strong>Сайт</strong>) является собственностью, включая все программно-технические средства, обеспечивающие работу Сайта, права на объекты интеллектуальной собственности на программы ЭВМ принадлежат <strong>ООО «Квартиль АйТи Инжиниринг»</strong>, ОГРН 1247800020280, ИНН/КПП 7807276183/780701001, юридический адрес: 198206, г. Санкт-Петербург, Петергофское шоссе 73 лит. Т, помещение 1-Н, оф. 31/1 (далее – <strong>Оператор</strong>).</p>
    <p>1.2. Настоящее Соглашение регулирует отношения между Оператором (Администрацией Сайта, действующей от имени Оператора) и Пользователем данного Сайта.</p>
    <p>1.3. Продолжение использования Сайта Пользователем означает полное и безоговорочное принятие условий настоящего Соглашения и любых изменений, внесенных в него.</p>
    <p>1.4. Пользователь несет персональную ответственность за регулярную проверку настоящего Соглашения на наличие изменений. Изменения вступают в силу с момента их публикации на Сайте, если иное не предусмотрено новой редакцией Соглашения.</p>
    {/* <p>
      1.1. Настоящее Пользовательское соглашение (далее – Соглашение) относится
      к Сайту Интернет-сервиса «Simpo», расположенному по адресу {SITE_URL}, и
      ко всем соответствующим Сайтам, связанным с Сайтом Интернет-сервиса.
    </p>
    <p>
      1.2. Сайт Интернет-сервиса «Simpo Online» (далее – Сайт) является
      собственностью, включая все программно-технические средства,
      обеспечивающие работу Сайта, права на объекты интеллектуальной
      собственности на программы ЭВМ принадлежат Индивидуальному предпринимателю
      Москалевой Алене Владимировне ИНН 519056342309, ОГРН 317784700351214 (г.
      Санкт-Петербург, ул. Адмирала Черокова, 18)
    </p>
    <p>
      1.3. Настоящее Соглашение регулирует отношения между Администрацией Сайта
      Интернет- сервиса «Simpo» (далее – Администрация Сайта) и Пользователем
      данного Сайта.
    </p>
    <p>
      1.4. Продолжение использования Сайта Пользователем означает принятие
      Соглашения и изменений, внесенных в настоящее Соглашение.
    </p>
    <p>
      1.5. Пользователь несет персональную ответственность за проверку
      настоящего Соглашения на наличие изменений в нем.
    </p> */}
    <h2>2. ОПРЕДЕЛЕНИЯ ТЕРМИНОВ</h2>
    <p>2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения следующее значение:</p>
    <ol>
        <li><strong>Оператор</strong> – ООО «Квартиль АйТи Инжиниринг», ОГРН 1247800020280, ИНН/КПП 7807276183/780701001, юридический адрес: 198206, г. Санкт-Петербург, Петергофское шоссе 73 лит. Т, помещение 1-Н, оф. 31/1.</li>
        <li><strong>Администрация Сайта</strong> - уполномоченные представители Оператора, осуществляющие техническую и консультационную поддержку Сайта, а также управление его функционалом.</li>
        <li><strong>Интернет-Сервис (Сервис)</strong> - совокупность программных и аппаратных средств для ЭВМ, обеспечивающих публикацию для обозрения информации и данных, объединенных общим целевым назначением, посредством технических средств, применяемых для связи между ЭВМ в сети Интернет. Под понятием Сервиса понимается Сайт и/или Приложение в информационно-телекоммуникационной сети Интернет, расположенный по адресу <a href="https://lakki-app.com">https://lakki-app.com</a>.</li>
        <li><strong>Пользователь Сайта (Пользователь)</strong> – лицо, имеющее доступ к Сайту посредством сети Интернет и использующее Сайт. К Пользователям относятся, в частности, Мастера и Заказчики услуг.</li>
        <li><strong>Мастер</strong> — Пользователь Сайта, зарегистрированный на Сайте в качестве Продавца услуг, предлагающий и оказывающий услуги Заказчикам услуг с использованием Сервиса.</li>
        <li><strong>Заказчик услуг</strong> – Пользователь Сайта, зарегистрированный на Сайте в качестве Покупателя, заключающий с Мастером соглашение об оказании услуг, используя функционал Сайта.</li>
        <li><strong>Клиент Мастера</strong> – физическое лицо, чьи персональные данные (имена, номера телефонов, даты рождения и т.п.) загружаются Мастером в Сервис для целей управления клиентской базой, отправки напоминаний об онлайн-записях и создания аналитических отчетов.</li>
        <li><strong>Стороны</strong> – Заказчик услуг и Мастер при их совместном упоминании в рамках соглашений об оказании услуг, а Сторона – любое из них при упоминании по отдельности. В контексте настоящего Соглашения, Сторонами являются Оператор и Пользователь.</li>
        <li><strong>Партнер</strong> - Пользователь Сервиса, являющийся участником Партнерской программы, распространяющий реферальные ссылки с целью привлечения Рефералов.</li>
        <li><strong>Партнерская программа</strong> - формат взаимодействия между Оператором, Мастерами и Заказчиками услуг, в рамках которого Партнер распространяет реферальные ссылки, приглашая других Пользователей зарегистрироваться в Сервисе.</li>
        <li><strong>Реферал</strong> - Пользователь, приглашенный в Сервис участником Партнерской программы, зарегистрировавшийся в системе и начавший совершать сделки от своего имени в системе.</li>
        <li><strong>Содержание Сайта</strong> - охраняемые результаты интеллектуальной деятельности, включая тексты литературных произведений, их названия, предисловия, аннотации, статьи, иллюстрации, обложки, музыкальные произведения с текстом или без текста, графические, текстовые, фотографические, производные, составные и иные произведения, пользовательские интерфейсы, визуальные интерфейсы, названия товарных знаков, логотипы, программы для ЭВМ, базы данных, а также дизайн, структура, выбор, координация, внешний вид, общий стиль и расположение данного Содержания, входящего в состав Сайта и другие объекты интеллектуальной собственности все вместе и/ или по отдельности, содержащиеся на Сайте Сервиса.</li>
        </ol>
    {/* <p>
      2.1. Перечисленные ниже термины имеют для целей настоящего Соглашения
      следующее значение:
    </p>
    <p>
      <strong>2.1. Администрация Сайта</strong> - представители Сервиса,
      осуществляющие техническую поддержку Сервиса и консультационную поддержку
      Пользователей, действующие от лица и в интересах Организации.
    </p>
    <p>
      <strong>2.2. Клиент</strong> – пользователь Сайта, зарегистрированный на
      Сайте в качестве Покупателя, заключивший с Мастером Соглашение, используя
      Защищенные страницы Сайта. Клиентом может быть полностью дееспособное
      физическое лицо, резидентом или нерезидентом Российской Федерации, а также
      индивидуальный предприниматель, зарегистрированный в соответствии с
      законодательством Российской Федерации или любого иного государства, а
      также юридическое лицо, созданное в соответствии с законодательством
      Российской Федерации или любого иного государства.
    </p>
    <p>
      <strong>2.3. Мастер</strong> — пользователь Сайта, зарегистрированный на
      Сайте в качестве Продавца услуг, заключивший с Клиентом Соглашение.
      Мастером может быть полностью дееспособное физическое лицо, достигшее
      восемнадцатилетнего возраста, резидентом или нерезидентом Российской
      Федерации, а также индивидуальный предприниматель, зарегистрированный в
      соответствии с законодательством Российской Федерации или любого иного
      государства, атакже юридическое лицо, созданное в соответствии с
      законодательством Российской Федерации или любого иного государства.
    </p>
    <p>
      <strong>2.4. Интернет-Сервис</strong> - совокупность программных и
      аппаратных средств для ЭВМ, обеспечивающих публикацию для обозрения
      информации и данных, объединенных общим целевым назначением, посредством
      технических средств, применяемых для связи между ЭВМ в сети Интернет.
      Иными словами под понятием Сервиса понимается Сайт/Приложение в
      информационно-телекоммуникационной сети Интернет, расположенный по адресу{" "}
      {SITE_URL}
    </p>
    <p>
      <strong>2.5. Стороны</strong> – Клиент и Мастер при их совместном
      упоминании, а Сторона – любое из них при упоминании по отдельности.
    </p>
    <p>
      <strong>2.6. «Simpo»</strong> – Интернет-сервис, расположенный на доменном
      имени {SITE_URL}, осуществляющий свою деятельность посредством
      Интернет-ресурса и сопутствующих ему сервисов.
    </p>
    <p>
      <strong>2.7. Партнер</strong> - Пользователь Интернет-сервиса, Клиент или
      Мастер, являющийся участником Партнерской программы, распространяющий
      реферальные ссылки с целью привлечения рефералов.
    </p>
    <p>
      <strong>2.8. Партнерская программа</strong> - формат взаимодействия между
      Интернет-сервисом, Клиентами и Мастерами, в рамках которого Партнер
      распространяет реферальные ссылки, приглашая других Пользователей
      зарегистрироваться в Интернет-сервисе.
    </p>
    <p>
      <strong>
        2.9. Пользователь Сайта Интернет-сервиса (далее - Пользователь)
      </strong>{" "}
      – лицо, имеющее доступ к Сайту посредством сети Интернет и использующее
      Сайт.
    </p>
    <p>
      <strong>2.10. Реферал</strong> - Пользователь, приглашенный в
      Интернет-сервис участником Партнерской программы, зарегистрировавшийся в
      системе и начавший совершать сделки от своего имени в системе.
    </p>
    <p>
      <strong>
        2.11. Содержание Сайта Интернет-сервиса (далее – Содержание)
      </strong>{" "}
      - охраняемые результаты интеллектуальной деятельности, включая тексты
      литературных произведений, их названия, предисловия, аннотации, статьи,
      иллюстрации, обложки, музыкальные произведения с текстом или без текста,
      графические, текстовые, фотографические, производные, составные и иные
      произведения, пользовательские интерфейсы, визуальные интерфейсы, названия
      товарных знаков, логотипы, программы для ЭВМ, базы данных, а также дизайн,
      структура, выбор, координация, внешний вид, общий стиль и расположение
      данного Содержания, входящего в состав Сайта и другие объекты
      интеллектуальной собственности все вместе и/ или по отдельности,
      содержащиеся на Сайте Интернет-сервиса.
    </p> */}
    <h2>3. ПРЕДМЕТ СОГЛАШЕНИЯ</h2>
    <p>3.1. Предметом настоящего Соглашения является предоставление Пользователю доступа к функционалу Сервиса, включая:</p>
    <ol>
        <li>доступ к электронному контенту, размещаемому на страницах Сервиса;</li>
        <li>доступ к средствам поиска и навигации Сервиса;</li>
        <li>предоставление Пользователю возможности размещения услуг, промо-акций, объявлений, сообщений, комментариев, отзывов, выставления оценок контенту других Пользователей Сервиса;</li>
        <li>доступ к информации об услугах Мастеров и к информации о приобретении Услуги на платной основе;</li>
        <li>доступ к сервисам управления бизнесом, взаимоотношениям с клиентами, информирования и др.;</li>
        <li>иные виды услуг, реализуемые на страницах Сервиса.</li>
    </ol>
    <p>3.1.1. Сервис предоставляет Пользователю платформу для взаимодействия. Оператор не несёт ответственности за качество оказываемых Мастерами услуг, выполняя лишь информационно-справочную роль во взаимоотношениях Заказчика услуг и Мастера.</p>
    <p>3.1.2. Под действие настоящего Соглашения подпадают все существующие (реально функционирующие) на данный момент услуги Сервиса, а также любые их последующие модификации и появляющиеся в дальнейшем дополнительные услуги.</p>

    <p>3.2. Доступ к Сервису предоставляется на бесплатной основе. При оплате услуг по схеме "Безопасная сделка" Заказчик услуг оплачивает только стоимость Услуг конкретного Мастера. Мастер оплачивает комиссию Сервиса в фиксированном размере 8% за каждую состоявшуюся Сделку по факту оплаты услуги Заказчиком услуг. При запросе возврата денежных средств при отказе от покупки, возврат производится исключительно на ту же банковскую карту, с которой была произведена оплата.</p>

    <p>3.3. Настоящее Соглашение является публичной офертой. Получая доступ к Сайту и/или используя его функционал, Пользователь считается присоединившимся к настоящему Соглашению.</p>
    <p>3.4. Использование материалов и сервисов Сайта регулируется нормами действующего законодательства Российской Федерации.</p>
    {/* <p>
      3.1. Предметом настоящего Соглашения является предоставление Пользователю
      Интернет-сервиса доступа к информации об оказываемых услугах
      специалистами, анкеты с предложениями которых размещены на Сайте, а также
      к контенту, владельцем которого являются другие Пользователи.
      Интернет-сервис не несёт ответственности за качество оказываемых услуг,
      выполняя лишь информационно-справочную роль во взаимоотношениях Клиента и
      Мастера.
    </p>
    <p>
      3.1.1. Интернет-сервис предоставляет Пользователю следующие виды услуг:
    </p>
    <ul>
      <li>
        доступ к электронному контенту, размещаемому на страницах
        Интернет-сервиса;
      </li>
      <li>доступ к средствам поиска и навигации Интернет-сервиса;</li>
      <li>
        предоставление Пользователю возможности размещения услуг, промо-акций,
        объявлений, сообщений, комментариев, отзывов, выставления оценок
        контенту других Пользователей Интернет-сервиса;
      </li>
      <li>
        доступ к информации об услугах и к информации о приобретении Услуги на
        платной основе;
      </li>
      <li>
        доступ к сервисам управления бизнесом, взаимоотношениям с клиентами,
        информирования и др.;
      </li>
      <li>иные виды услуг, реализуемые на страницах Интернет-сервиса.</li>
    </ul>
    <p>
      3.1.2. Под действие настоящего Соглашения подпадают все существующие
      (реально функционирующие) на данный момент услуги Интернет-сервиса, а
      также любые их последующие модификации и появляющиеся в дальнейшем
      дополнительные услуги.
    </p>
    <p>
      3.2. Доступ к Интернет-сервису предоставляется на бесплатной основе. При
      оплате услуг по схеме "Безопасная сделка" клиент оплачивает только
      стоимость Услуг конкретного Мастера. Мастер оплачивает комиссию
      Интернет-сервиса в фиксированном размере 12% за каждую Сделку по факту
      оплаты клиентом услуги мастера. При запросе возврата денежных средств при
      отказе от покупки, возврат производится исключительно на ту же банковскую
      карту, с которой была произведена оплата.
    </p>
    <p>
      3.3. Настоящее Соглашение является публичной офертой. Получая доступ к
      Сайту Пользователь считается присоединившимся к настоящему Соглашению.
    </p>
    <p>
      3.4. Использование материалов и сервисов Сайта регулируется нормами
      действующего законодательства Российской Федерации.
    </p> */}
    <h2>4. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
    <p>4.1. При регистрации и использовании сервиса «Lakki CRM» Мастер может загружать в систему свою клиентскую базу, содержащую персональные данные Клиентов Мастера, такие как: имена, номера телефонов, в некоторых случаях даты рождения.</p>
    <p>4.2. Мастер, загружая указанные данные, подтверждает и гарантирует Оператору, что он получил все необходимые согласия от своих Клиентов Мастера или имеет иное законное основание для передачи их персональных данных Оператору и для последующей обработки этих данных Оператором в соответствии с целями и способами, указанными в настоящем Соглашении и <a href="https://lakki-app.com/privacy-policy" target="_blank">Политике конфиденциальности</a> Сервиса, включая их трансграничную передачу.</p>
    <p>4.3. Оператор обрабатывает персональные данные Клиентов Мастера, предоставленные Мастером, исключительно в целях, необходимых для функционирования Сервиса и исполнения обязательств перед Мастером, а именно:</p>
    <ul>
        <li>для отправки напоминаний об онлайн-записях (посредством SMS-рассылок и сообщений через мессенджеры WhatsApp, Viber, Telegram);</li>
        <li>для создания аналитических отчетов и статистики для Мастера;</li>
        <li>для осуществления иных действий, предусмотренных функционалом Сервиса «Lakki CRM» и договором с Мастером.</li>
    </ul>
    <p>4.4. Оператор обрабатывает персональные данные Клиентов Мастера на основании поручения Мастера, который выступает в роли Оператора персональных данных по отношению к своим Клиентам Мастера. Ответственность за соблюдение требований законодательства о персональных данных при сборе, хранении и передаче данных Клиентов Мастера Оператору несет Мастер.</p>
    <p>4.5. Мастер несет полную ответственность за достоверность, полноту и актуальность персональных данных Клиентов Мастера, загруженных им в Сервис, а также за законность их получения и обработки.</p>
    <p>4.6. Оператор обязуется не использовать персональные данные Клиентов Мастера для целей, не связанных с предоставлением услуг Сервиса Мастеру, а также не передавать их третьим лицам, за исключением случаев, когда это необходимо для выполнения поручения Мастера (например, для рассылок через сторонние сервисы), или по требованию законодательства Российской Федерации. Обработка персональных данных Клиентов Мастера регулируется <a href="https://lakki-app.com/privacy-policy" target="_blank">Политикой конфиденциальности</a> Сервиса.</p>
    {/* <strong>4.1. Администрация Сайта вправе:</strong>
    <p>
      4.1.1. Изменять правила пользования Сайтом, а также изменять содержание
      данного Сайта. Изменения вступают в силу с момента публикации новой
      редакции Соглашения на Сайте.
    </p>
    <p>
      4.1.2. Ограничить доступ к Сайту в случае нарушения Пользователем условий
      настоящего Соглашения.
    </p>
    <p>
      4.1.3. Изменять размер оплаты, взимаемый за предоставление доступа к
      использованию Сайта Интернет-сервиса.
    </p>
    <strong>4.2. Пользователь вправе:</strong>
    <p>
      4.2.1. Получить доступ к использованию Сайта после соблюдения требований о
      регистрации оплате.
    </p>
    <p>4.2.2. Пользоваться всеми имеющимися на Сайте услугами.</p>
    <p>
      4.2.3. Задавать любые вопросы, относящиеся к услугам Интернет-сервиса по
      реквизитам, которые находятся в футере сайта.
    </p>
    <p>
      4.2.4. Пользоваться Сайтом исключительно в целях и порядке,
      предусмотренных Соглашением и не запрещенных законодательством Российской
      Федерации.
    </p>
    <strong>4.3. Пользователь Сайта обязуется:</strong>
    <p>
      4.3.1. Предоставлять по запросу Администрации Сайта дополнительную
      информацию, которая имеет непосредственное отношение к предоставляемым
      услугам данного Сайта.
    </p>
    <p>
      4.3.2. Соблюдать имущественные и неимущественные права авторов и иных
      правообладателей при использовании Сайта.
    </p>
    <p>
      4.3.3. Не предпринимать действий, которые могут рассматриваться как
      нарушающие нормальную работу Сайта.
    </p>
    <p>
      4.3.4. Не распространять с использованием Сайта любую конфиденциальную и
      охраняемую законодательством Российской Федерации информацию о физических
      либо юридических лицах.
    </p>
    <p>
      4.3.5. Избегать любых действий, в результате которых может быть нарушена
      конфиденциальность охраняемой законодательством Российской Федерации
      информации.
    </p>
    <p>
      4.3.6. Не использовать Сайт для распространения информации рекламного
      характера, иначе как с согласия Администрации Сайта.
    </p>
    <p>4.3.7. Не использовать сервисы Сайта Интернет-сервиса с целью:</p>
    <p>
      4.3.7.1. Загрузки контента, который является незаконным, нарушает любые
      права третьих лиц; пропагандирует насилие, жестокость, ненависть и (или)
      дискриминацию по расовому, национальному, половому, религиозному,
      социальному признакам; содержит недостоверные сведения и (или) оскорбления
      в адрес конкретных лиц, организаций, органов власти.
    </p>
    <p>
      4.3.7.2. Побуждения к совершению противоправных действий, а также
      содействия лицам, действия которых направлены на нарушение ограничений и
      запретов, действующих на территории Российской Федерации.
    </p>
    <p>
      4.3.7.3. Нарушения прав несовершеннолетних лиц и (или) причинение им вреда
      в любой форме.
    </p>
    <p>4.3.7.4. Ущемления прав меньшинств.</p>
    <p>
      4.3.7.5. Представления себя за другого человека или представителя
      организации и (или) сообщества без достаточных на то прав, в том числе за
      сотрудников данного Интернет- сервиса.
    </p>
    <p>
      4.3.7.6. Введения в заблуждение относительно свойств и характеристик
      какой-либо Услуги из каталога Интернет-сервиса, размещенного на Сайте.
    </p>
    <p>
      4.3.7.7. Некорректного сравнения Услуги, а также формирования негативного
      отношения к лицам, (не) пользующимся определенными Услугами, или осуждения
      таких лиц.
    </p>
    <p>
      4.3.8. Исполнять свои обязательства, связанные с уплатой налогов и других
      сборов в бюджет Российской Федерации, если такие возникают в процессе
      использования Интернет-сервиса, в т.ч. налог на доходы физических лиц или
      самозанятых, налог на прибыль, взносы на обязательное пенсионное
      страхование и пр.
    </p>
    <strong>4.4. Пользователю запрещается:</strong>
    <p>
      4.4.1. Использовать любые устройства, программы, процедуры, алгоритмы и
      методы, автоматические устройства или эквивалентные ручные процессы для
      доступа, приобретения, копирования или отслеживания содержания Сайта
      данного Интернет-сервиса;
    </p>
    <p>4.4.2. Нарушать надлежащее функционирование Сайта;</p>
    <p>
      4.4.3. Любым способом обходить навигационную структуру Сайта для получения
      или попытки получения любой информации, документов или материалов любыми
      средствами, которые специально не представлены сервисами данного Сайта;
    </p>
    <p>
      4.4.4. Несанкционированный доступ к функциям Сайта, любым другим системам
      или сетям, относящимся к данному Сайту, а также к любым услугам,
      предлагаемым на Сайте;
    </p>
    <p>
      4.4.5. Нарушать систему безопасности или аутентификации на Сайте или в
      любой сети, относящейся к Сайту.
    </p>
    <p>
      4.4.6. Выполнять обратный поиск, отслеживать или пытаться отслеживать
      любую информацию о любом другом Пользователе Сайта.
    </p>
    <p>
      4.4.7. Использовать Сайт и его Содержание в любых целях, запрещенных
      законодательством Российской Федерации, а также подстрекать к любой
      незаконной деятельности или другой деятельности, нарушающей права
      интернет-сервиса или других лиц.
    </p> */}
    <h2>5. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>
    <p>5.1. <strong>Оператор вправе:</strong></p>
    <ol>
        <li>Изменять правила пользования Сайтом, а также изменять содержание данного Сайта. Изменения вступают в силу с момента публикации новой редакции Соглашения на Сайте.</li>
        <li>Ограничить доступ к Сайту в случае нарушения Пользователем условий настоящего Соглашения.</li>
        <li>Изменять размер оплаты, взимаемый за предоставление доступа к использованию Сайта Сервиса.</li>
    </ol>

    <p>5.2. <strong>Пользователь вправе:</strong></p>
    <ol>
        <li>Получить доступ к использованию Сайта после соблюдения требований о регистрации и оплате (если применимо).</li>
        <li>Пользоваться всеми имеющимися на Сайте услугами в соответствии с их назначением.</li>
        <li>Задавать любые вопросы, относящиеся к услугам Сервиса, по реквизитам, указанным на Сайте.</li>
        <li>Пользоваться Сайтом исключительно в целях и порядке, предусмотренных Соглашением и не запрещенных законодательством Российской Федерации.</li>
    </ol>

    <p>5.3. <strong>Пользователь Сайта обязуется:</strong></p>
    <ol>
        <li>Предоставлять по запросу Администрации Сайта дополнительную информацию, которая имеет непосредственное отношение к предоставляемым услугам данного Сайта.</li>
        <li>Соблюдать имущественные и неимущественные права авторов и иных правообладателей при использовании Сайта.</li>
        <li>Не предпринимать действий, которые могут рассматриваться как нарушающие нормальную работу Сайта.</li>
        <li>Не распространять с использованием Сайта любую конфиденциальную и охраняемую законодательством Российской Федерации информацию о физических либо юридических лицах, за исключением случаев, когда такая передача необходима для законных целей использования Сервиса и Мастер получил на это необходимые согласия или имеет иное законное основание.</li>
        <li>Избегать любых действий, в результате которых может быть нарушена конфиденциальность охраняемой законодательством Российской Федерации информации.</li>
        <li>Не использовать Сайт для распространения информации рекламного характера, иначе как с согласия Оператора.</li>
        <li>Не использовать сервисы Сайта Сервиса с целью:
            <ol type="a">
                <li>Загрузки контента, который является незаконным, нарушает любые права третьих лиц; пропагандирует насилие, жестокость, ненависть и (или) дискриминацию по расовому, национальному, половому, религиозному, социальному признакам; содержит недостоверные сведения и (или) оскорбления в адрес конкретных лиц, организаций, органов власти.</li>
                <li>Побуждения к совершению противоправных действий, а также содействия лицам, действия которых направлены на нарушение ограничений и запретов, действующих на территории Российской Федерации.</li>
                <li>Нарушения прав несовершеннолетних лиц и (или) причинение им вреда в любой форме.</li>
                <li>Ущемления прав меньшинств.</li>
                <li>Представления себя за другого человека или представителя организации и (или) сообщества без достаточных на то прав, в том числе за сотрудников данного Сервиса.</li>
                <li>Введения в заблуждение относительно свойств и характеристик какой-либо Услуги, размещенной на Сайте.</li>
                <li>Некорректного сравнения Услуги, а также формирования негативного отношения к лицам, (не) пользующимся определенными Услугами, или осуждения таких лиц.</li>
            </ol>
        </li>
        <li>Исполнять свои обязательства, связанные с уплатой налогов и других сборов в бюджет Российской Федерации, если такие возникают в процессе использования Сервиса, в т.ч. налог на доходы физических лиц или самозанятых, налог на прибыль, взносы на обязательное пенсионное страхование и пр.</li>
    </ol>

    <p>5.4. <strong>Пользователю запрещается:</strong></p>
    <ol>
        <li>Использовать любые устройства, программы, процедуры, алгоритмы и методы, автоматические устройства или эквивалентные ручные процессы для доступа, приобретения, копирования или отслеживания содержания Сайта данного Сервиса.</li>
        <li>Нарушать надлежащее функционирование Сайта.</li>
        <li>Любым способом обходить навигационную структуру Сайта для получения или попытки получения любой информации, документов или материалов любыми средствами, которые специально не представлены сервисами данного Сайта.</li>
        <li>Осуществлять несанкционированный доступ к функциям Сайта, любым другим системам или сетям, относящимся к данному Сайту, а также к любым услугам, предлагаемым на Сайте.</li>
        <li>Нарушать систему безопасности или аутентификации на Сайте или в любой сети, относящейся к Сайту.</li>
        <li>Выполнять обратный поиск, отслеживать или пытаться отслеживать любую информацию о любом другом Пользователе Сайта.</li>
        <li>Использовать Сайт и его Содержание в любых целях, запрещенных законодательством Российской Федерации, а также подстрекать к любой незаконной деятельности или другой деятельности, нарушающей права Оператора или других лиц.</li>
    </ol>
{/*         
    <p>
      5.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется
      Администрацией Сайта.
    </p>
    <p>
      5.2. Содержание Сайта не может быть скопировано, опубликовано,
      воспроизведено, передано или распространено любым способом, а также
      размещено в глобальной сети «Интернет» без предварительного письменного
      согласия Администрации Сайта.
    </p>
    <p>
      5.3. Содержание Сайта защищено авторским правом, законодательством о
      товарных знаках, а также другими правами, связанными с интеллектуальной
      собственностью, и законодательством о недобросовестной конкуренции.
    </p>
    <p>
      5.4. Приобретение Товара, предлагаемого на Сайте, может потребовать
      создания учётной записи Пользователя.
    </p>
    <p>
      5.5. Пользователь несет персональную ответственность за сохранение
      конфиденциальности информации учётной записи, включая пароль, а также за
      всю без исключения деятельность, которая ведётся от имени Пользователя
      учётной записи.
    </p>
    <p>
      5.6. Пользователь должен незамедлительно уведомить Администрацию Сайта о
      несанкционированном использовании его учётной записи или пароля или любом
      другом нарушении системы безопасности.
    </p>
    <p>
      5.7. Администрация Сайта обладает правом в одностороннем порядке
      аннулировать учетную запись Пользователя, если она не использовалась более
      2 календарных месяцев подряд без уведомления Пользователя.
    </p>
    <p>
      5.8. Настоящее Соглашение распространяет свое действия на все
      дополнительные положения и условия о приобретении Услуг, предоставляемых
      на Сайте.
    </p>
    <p>
      5.9. Информация, размещаемая на Сайте не должна истолковываться как
      изменение настоящего Соглашения.
    </p>
    <p>
      5.10. Размещая фотографии, статьи и другой контент на страницах
      Интернет-сервиса и на страницах Личного кабинета, Пользователь
      гарантирует, что является автором контента, и дает право Интернет-сервису
      распоряжаться им по своему усмотрению, публиковать в различных
      интернет-ресурсах, использовать в качестве рекламных материалов на
      условиях неисключительной лицензии. В случае, если Пользователь размещает
      фотографии и контент, авторство на которые ему не принадлежит,
      ответственность за нарушение авторских прав правообладателя несет сам
      Пользователь.
    </p>
    <p>
      5.11. Любой из документов, перечисленных в пункте 5.11. настоящего
      Соглашения, может подлежать обновлению. Изменения вступают в силу с
      момента их опубликования на Сайте.
    </p> */}
    <h2>6. ИСПОЛЬЗОВАНИЕ САЙТА ИНТЕРНЕТ-СЕРВИСА</h2>

    <p>6.1. Сайт и Содержание, входящее в состав Сайта, принадлежит и управляется Оператором.</p>
    <p>6.2. Содержание Сайта не может быть скопировано, опубликовано, воспроизведено, передано или распространено любым способом, а также размещено в глобальной сети «Интернет» без предварительного письменного согласия Оператора.</p>
    <p>6.3. Содержание Сайта защищено авторским правом, законодательством о товарных знаках, а также другими правами, связанными с интеллектуальной собственностью, и законодательством о недобросовестной конкуренции.</p>
    <p>6.4. Приобретение Услуг, предлагаемых на Сайте, может потребовать создания учётной записи Пользователя.</p>
    <p>6.5. Пользователь несет персональную ответственность за сохранение конфиденциальности информации учётной записи, включая пароль, а также за всю без исключения деятельность, которая ведётся от имени Пользователя учётной записи.</p>
    <p>6.6. Пользователь должен незамедлительно уведомить Администрацию Сайта о несанкционированном использовании его учётной записи или пароля или любом другом нарушении системы безопасности.</p>
    <p>6.7. Оператор обладает правом в одностороннем порядке аннулировать учетную запись Пользователя, если она не использовалась более 2 календарных месяцев подряд без уведомления Пользователя.</p>
    <p>6.8. Настоящее Соглашение распространяет свое действия на все дополнительные положения и условия о приобретении Услуг, предоставляемых на Сайте.</p>
    <p>6.9. Информация, размещаемая на Сайте, не должна истолковываться как изменение настоящего Соглашения.</p>
    <p>6.10. Размещая фотографии, статьи и другой контент на страницах Сервиса и на страницах Личного кабинета, Пользователь гарантирует, что является автором контента, и дает право Оператору распоряжаться им по своему усмотрению, публиковать в различных интернет-ресурсах, использовать в качестве рекламных материалов на условиях неисключительной лицензии. В случае, если Пользователь размещает фотографии и контент, авторство на которые ему не принадлежит, ответственность за нарушение авторских прав правообладателя несет сам Пользователь.</p>
    <p>6.11. Пользователь несет ответственность за использование товарных знаков, принадлежащих третьим лицам. В случае возникновения споров Оператора с правообладателем товарного знака, Оператор вправе обратиться в суд за возмещением убытков, которые будут понесены в результате разбирательств с правообладателем. Также Оператор оставляет за собой право предоставить все данные Пользователя правообладателю или его представителю с целью возможности взыскания убытков, понесенных правообладателем, в результате противоправной деятельности Пользователя.</p>
    <p>6.11. Любой из документов, перечисленных в разделе 6 настоящего Соглашения (включая Политику конфиденциальности и условия Партнерской программы), может подлежать обновлению. Изменения вступают в силу с момента их опубликования на Сайте.</p>

    {/* <h2>6. УЧАСТИЕ В ПАРТНЕРСКОЙ ПРОГРАММЕ</h2>
    <p>
      6.1. Участию в Партнерской программе допускаются любые Пользователи,
      зарегистрировавшиеся в Интернет-сервисе в качестве Клиента или Мастера.
    </p>
    <p>
      6.2. Партнер Интернет-сервиса распространяет реферальные ссылки,
      генерируемые в Личном кабинете, привлекая Рефералов зарегистрироваться в
      Интернет-сервисе любым доступным способом, используя всевозможные каналы
      коммуникации.
    </p>
    <p>
      6.3. Вознаграждение Партнера отображается в Личном кабинете и
      рассчитывается как 5% от подтвержденных трат Клиента и 4% от
      подтвержденного заработка Мастера в Интернет-сервисе.
    </p>
    <p>
      6.4. Платежи Партнерам осуществляются по запросу не чаще 2 раз в месяц по
      достижении минимальной суммы выплат, установленной Интернет-сервисом,
      посредством сервиса Яндекс.Касса.
    </p>
    <p>
      6.5. Интернет-сервис не несет расходов, связанных с привлечением Рефералов
      Партнером.
    </p>
    <p>
      6.6. Интернет-сервис не берет на себя функции налогового агента и
      возлагает ответственность по уплате налоговых, пенсионных и иных взносов,
      предусмотренных законодательством РФ, на Партнера.
    </p>
    <p>
      6.7. Интернет-сервис оставляет за собой право в любой момент изменить
      условия Партнерской программы, в том числе отказаться от ее использования.
    </p> */}
    <h2>7. ОТВЕТСТВЕННОСТЬ</h2>
    <p>7.1. Любые убытки, которые Пользователь может понести в случае умышленного или неосторожного нарушения любого положения настоящего Соглашения, а также вследствие несанкционированного доступа к коммуникациям другого Пользователя, не возмещаются Оператором в пределах, допускаемых законодательством Российской Федерации.</p>
    <p>7.2. Оператор не несет ответственности за:</p>
    <ol>
        <li>Задержки или сбои в процессе совершения операции, возникшие вследствие непреодолимой силы, а также любого случая неполадок в телекоммуникационных, компьютерных, электрических и иных смежных системах.</li>
        <li>Действия систем переводов, банков, платежных систем и за задержки, связанные с их работой.</li>
        <li>Надлежащее функционирование Сайта, в случае, если Пользователь не имеет необходимых технических средств для его использования, а также не несет никаких обязательств по обеспечению пользователей такими средствами.</li>
    </ol>


    <h2>8. НАРУШЕНИЕ УСЛОВИЙ ПОЛЬЗОВАТЕЛЬСКОГО СОГЛАШЕНИЯ</h2>
    <p>8.1. Оператор вправе раскрыть любую собранную о Пользователе данного Сайта информацию, если раскрытие необходимо в связи с расследованием или жалобой в отношении неправомерного использования Сайта либо для установления (идентификации) Пользователя, который может нарушать или вмешиваться в права Оператора или в права других Пользователей Сайта. Условия раскрытия персональных данных регулируются <a href="https://lakki-app.com/privacy-policy" target="_blank">Политикой конфиденциальности</a> Сервиса.</p>
    <p>8.2. Оператор имеет право раскрыть любую информацию о Пользователе, которую посчитает необходимой для выполнения положений действующего законодательства или судебных решений, обеспечения выполнения условий настоящего Соглашения, защиты прав или безопасности Оператора, Пользователей.</p>
    <p>8.3. Оператор имеет право раскрыть информацию о Пользователе, если действующее законодательство Российской Федерации требует или разрешает такое раскрытие.</p>
    <p>8.4. Оператор вправе без предварительного уведомления Пользователя прекратить и (или) заблокировать доступ к Сайту, если Пользователь нарушил настоящее Соглашение или содержащиеся в иных документах условия пользования Сайтом, а также в случае прекращения действия Сайта либо по причине технической неполадки или проблемы.</p>
    <p>8.5. Оператор не несет ответственности перед Пользователем или третьими лицами за прекращение доступа к Сайту в случае нарушения Пользователем любого положения настоящего Соглашения или иного документа, содержащего условия пользования Сайтом.</p>
    {/* <p>
      8.1. Администрация Сайта вправе раскрыть любую собранную о Пользователе
      данного Сайта информацию, если раскрытие необходимо в связи с
      расследованием или жалобой в отношении неправомерного использования Сайта
      либо для установления (идентификации) Пользователя, который может нарушать
      или вмешиваться в права Администрации Сайта или в права других
      Пользователей Сайта.
    </p>
    <p>
      8.2. Администрация Сайта имеет право раскрыть любую информацию о
      Пользователе, которую посчитает необходимой для выполнения положений
      действующего законодательства или судебных решений, обеспечения выполнения
      условий настоящего Соглашения, защиты прав или безопасности название
      организации, Пользователей.
    </p>
    <p>
      8.3. Администрация Сайта имеет право раскрыть информацию о Пользователе,
      если действующее законодательство Российской Федерации требует или
      разрешает такое раскрытие.
    </p>
    <p>
      8.4. Администрация Сайта вправе без предварительного уведомления
      Пользователя прекратить и (или) заблокировать доступ к Сайту, если
      Пользователь нарушил настоящее Соглашение или содержащиеся в иных
      документах условия пользования Сайтом, а также в случае прекращения
      действия Сайта либо по причине технической неполадки или проблемы.
    </p>
    <p>
      8.5. Администрация Сайта не несет ответственности перед Пользователем или
      третьими лицами за прекращение доступа к Сайту в случае нарушения
      Пользователем любого положения настоящего Соглашения или иного документа,
      содержащего условия пользования Сайтом.
    </p> */}
    <h2>9. РАЗРЕШЕНИЕ СПОРОВ</h2>
    <p>9.1. В случае возникновения любых разногласий или споров между Сторонами настоящего Соглашения обязательным условием до обращения в суд является предъявление претензии (письменного предложения о добровольном урегулировании спора).</p>
    <p>9.2. Получатель претензии в течение 30 календарных дней со дня ее получения, письменно уведомляет заявителя претензии о результатах рассмотрения претензии.</p>
    <p>9.3. При невозможности разрешить спор в добровольном порядке любая из Сторон вправе обратиться в суд за защитой своих прав, которые предоставлены им действующим законодательством Российской Федерации.</p>
    <p>9.4. Споры, не разрешенные в добровольном порядке, подлежат разрешению в Арбитражном суде г. Санкт-Петербурга.</p>
    {/* <p>
      9.1. В случае возникновения любых разногласий или споров между Сторонами
      настоящего Соглашения обязательным условием до обращения в суд является
      предъявление претензии (письменного предложения о добровольном
      урегулировании спора).
    </p>
    <p>
      9.2. Получатель претензии в течение 30 календарных дней со дня ее
      получения, письменно уведомляет заявителя претензии о результатах
      рассмотрения претензии.
    </p>
    <p>
      9.3. При невозможности разрешить спор в добровольном порядке любая из
      Сторон вправе обратиться в суд за защитой своих прав, которые
      предоставлены им действующим законодательством Российской Федерации.
    </p>
    <p>
      9.4. Любой иск в отношении условий использования Сайта должен быть
      предъявлен в течение 3 (трех) дней после возникновения оснований для иска,
      за исключением защиты авторских прав на охраняемые в соответствии с
      законодательством материалы Сайта. При нарушении условий данного пункта
      любой иск или основания для иска погашаются исковой давностью.
    </p>
    <p>
      9.5. В случае если не удается разрешить возникшие между сторонами споры
      и/или разногласия путем переговоров, то такие споры разрешаются в
      Арбитражном суде г. Санкт-Петербург.
    </p> */}
    <h2>10. ДОПОЛНИТЕЛЬНЫЕ УСЛОВИЯ</h2>
    <p>10.1. Оператор не принимает встречные предложения от Пользователя относительно изменений настоящего Пользовательского соглашения.</p>
    <p>10.2. Отзывы Пользователя, размещенные на Сайте, не являются конфиденциальной информацией и могут быть использованы Оператором без ограничений, при условии соблюдения применимого законодательства о персональных данных в части данных, которые могут содержаться в отзывах.</p>
    <p>10.3. Вопросы, не урегулированные настоящим Соглашением, регулируются законодательством Российской Федерации.</p>
  </>
);
